import slugify from 'react-slugify';
import { Helmet } from 'react-helmet';
import React, {useEffect} from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import '../scss/thankyou.scss';
import { WEB_URL } from '../api/URLs';
import { donationActions } from '../store/actions';
import Tracking from '../services/tracking.service';
import { donationConstants } from '../store/actionTypes';
import { useNonInitialEffect } from '../hooks/UseNonInitialEffect';
import { Header, Footer, P, Span, MixPanelTrackedLink } from '../components';
import { GTM_EVENTS, PAYMENT_INITITATED_FALG, S3_BUCKET } from '../constants';

const TITLE = 'Thank you for your Donation';
const DESCRIPTION = 'Thank you for your Donation, this will impact our children.';

export function ThankYou() {
    const dispatch = useDispatch();
    const { trasanctionNumber } = useParams();
    const donationDetails = useSelector(state => state.updateDonationDetails.donation_details);

    useEffect(() => {
        dispatch(donationActions.updateLoaderState(true));
        dispatch(donationActions.getDonationDetails(trasanctionNumber));
    }, [])

    useNonInitialEffect(() => {
        const isPaymentInititated = localStorage.getItem(PAYMENT_INITITATED_FALG);
        if (isPaymentInititated) {
            Tracking.trackGTM({
                event: GTM_EVENTS.PAYMENT_CONFIRMED,
                fundraiser_name: donationDetails.data.page_title,
                raised_amount: donationDetails.data.total_fund_raised,
                number_of_donation: donationDetails.data.count_donations,
                goal_amount: donationDetails.data.fundraising_goal,
                payment_type: donationDetails.data.is_recurring ? "recurring" : "one time",
                currency: donationDetails.data.currency_code,
                donation_amount: donationDetails.data.donation_amount,
                is_annonymous: donationDetails.data.is_anonymous ? true : false,
                payment_mode: donationDetails.data.payment_method_name,
                donation_type: donationDetails.data.donation_type,
                transaction_id: donationDetails.data.donation_id
            });
            localStorage.removeItem(PAYMENT_INITITATED_FALG)
        }
    }, [donationDetails])

    return <div className="thankyou App-display-height">
        <Header />
        <Helmet>
            <title>{TITLE}</title>
            <meta name="description" content={DESCRIPTION} />
        </Helmet>
        <main className="App-content">
            <div className="container">
                {donationDetails &&
                    <div className="">
                        <div className="row justify-content-md-center">
                            <div className="col-md-10">
                                <div className="white-border-box">
                                    <div className="d-flex flex-row justify-content-start">
                                        <div className="back-to-link d-flex">
                                            {(donationDetails.data.donated_campaign_name
                                                ? <P><a href={WEB_URL.CAMPAIGN_DETAILS(donationDetails.data.donated_campaign_event_id)} className="">{"< Back to fundraiser"}</a></P>
                                                : <P><a href={WEB_URL.FUNDRAISER_DETAILS(donationDetails.data.event_id, slugify(donationDetails.data.page_title))} className="">{"< Back to fundraiser"}</a></P>
                                            )}
                                        </div>
                                    </div>
                                    <div className="page-heading">
                                        <Span className="ph-icon">
                                            <i className="icon-tcf-check"></i>
                                        </Span>
                                        <Span className="ph-txt">Thank you for your donation, {donationDetails.data.donor_name}</Span>
                                    </div>
                                    <div className="thk-message">
                                        {donationDetails.data.is_special !== 1 &&
                                            <>
                                                <P>Your contribution makes all the difference in the lives of the most vulnerable children in Pakistan.</P><br />
                                                <P>By providing the gift of education, you empower children to dream big and to build a better life for themselves, their families, and communities. </P>
                                            </>
                                        }
                                    </div>
                                    <hr />

                                    <div className="transaction-detail">
                                        <ul className="transaction-record-list">
                                            {donationDetails.data.fundraiser_name &&
                                                <li className="">
                                                    <div className="left-txt">Fundraiser:</div>
                                                    <div className="right-txt">{donationDetails.data.page_title}</div>
                                                </li>
                                            }
                                            {donationDetails.data.donated_campaign_name &&
                                                <li className="">
                                                    <div className="left-txt">Campaign:</div>
                                                    <div className="right-txt">{donationDetails.data.donated_campaign_name}</div>
                                                </li>
                                            }
                                            {donationDetails.data.campaign_name &&
                                                <li className="">
                                                    <div className="left-txt">Campaign:</div>
                                                    <div className="right-txt">{donationDetails.data.campaign_name}</div>
                                                </li>
                                            }
                                            <li className="">
                                                <div className="left-txt">Amount:</div>
                                                <div className="right-txt">{donationDetails.data.symbol_left + " " + (donationConstants.AMOUNT_FORMAT.includes(donationDetails.data.currency_code) ? donationDetails.data.donation_amount.toLocaleString('de-DE') : donationDetails.data.donation_amount.toLocaleString())} {donationDetails.data.transaction_fee_amount > 0 && 'with fees included.'}</div>
                                            </li>
                                            <li className="">
                                                <div className="left-txt">Currency:</div>
                                                <div className="right-txt">{donationDetails.data.currency_code}</div>
                                            </li>
                                            <li className="">
                                                <div className="left-txt">Frequency:</div>
                                                <div className="right-txt">{(donationDetails.data.is_recurring == 1 ? 'Monthly' : 'One time')}</div>
                                            </li>
                                            <li className="">
                                                <div className="left-txt">Payment method:</div>
                                                <div className="right-txt">{donationDetails.data.payment_method_name + (donationDetails.data.bank_name ? ' (' + donationDetails.data.bank_name + ')' : '')}</div>
                                            </li>
                                            <li className="">
                                                <div className="left-txt">Transaction date:</div>
                                                <div className="right-txt">{donationDetails.data.transaction_date}</div>
                                            </li>
                                            <li className="">
                                                <div className="left-txt">Transaction number:</div>
                                                <div className="right-txt">{donationDetails.data.donation_id}</div>
                                            </li>
                                            <li className="">
                                                <div className="left-txt">Status:</div>
                                                <div className="right-txt">{donationDetails.data.donation_status}</div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="bottom-txt">
                                        <div className="bottom-text-flex">
                                            <P>You will receive a confirmation email with your donation acknowledgment from {donationDetails.data.partner_title}.</P>
                                            {donationDetails.data.currency_code !== 'CAD' &&
                                                <div className="pdf-link pdfLinkButton d-flex ml-auto">
                                                    <MixPanelTrackedLink type="button" variant="outlined" href={S3_BUCKET + 'receipt/Donation Receipt ' + donationDetails.data.donation_id + '.pdf'}>Save as PDF</MixPanelTrackedLink>
                                                    {/* <a className="green-border-btn" href={S3_BUCKET + 'receipt/Donation Receipt ' + donation_details.data.donation_id + '.pdf'}>Save as PDF</a> */}
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className="pg-bottom-area">
                                        <P>{donationDetails.data.taxes_message}</P>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </main>
        <Footer />
    </div>
}
